module.exports = __webpack_public_path__ + "img/geo-zone.a097b442.svg";